module.exports = "/assets/data/b34b3aca35e69250d8d65fb5f0988296-TD6.data.json";